import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';

export default function AboutCard(props) {
    const item = props.item;
    // console.log(item);
    if (item) {
        return (
            <Card sx={{ maxWidth: 345 }}>
                <CardActionArea>
                    <CardMedia
                        component="img"
                        height="180"
                        image={item['image']}
                        alt="RLC of VA image"
                        />
                        <CardContent>
                        <Typography gutterBottom variant="h5" component="div" style={{textAlign: 'left'}}>
                            {item['title']}
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'text.secondary' }}  style={{textAlign: 'left'}}>
                            {item['summary']}
                        </Typography>
                    </CardContent>
                </CardActionArea>
            </Card>
        );
    } else {
        return (
            <div></div>
        )
    }
}